import React, { useEffect } from 'react';
import { Form, Modal, Row, Col, Input, Button } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';
import {
  MailReportPayload,
  ExportReport,
} from 'utils/apiClient/services/reports/types';
import StyledForm from 'Common/Components/Form';

const FormItem = Form.Item;

export interface DeleteOptions {
  id: number;
  new_tax: number;
}

interface Props {
  visible: boolean;
  onClose: () => void;
  header: string | null;
  message: MailReportPayload;
  onSubmit: (body: ExportReport) => void;
}

export type MailReportFormValues = {
  email: string;
  children?: React.ReactNode;
};

const MailReportModal: React.FC<Props> = ({
  visible,
  header,
  message,
  onSubmit,
  onClose,
}) => {
  const intl = useIntl();

  const [form] = Form.useForm<MailReportFormValues>();

  useEffect(() => {
    form.resetFields();
    if (message) {
      form.setFields([{ name: 'email', value: message.email }]);
    }
  }, [form, message]);

  const handleSubmit = () =>
    form.validateFields().then((values) => {
      onSubmit({
        email: values.email.trim(),
        end: message.end,
        format: message.format,
        start: message.start,
        type: 'range',
        reportType: header,
      });
      onClose();
    });

  return (
    <>
      <Modal
        width="510px"
        open={visible}
        title={
          <div
            css={`
              margin-left: 10px;
            `}
          >
            <FormattedMessage defaultMessage="Send" />
            <span>{` "${header}" `}</span>
            <FormattedMessage defaultMessage="to this email address" />
          </div>
        }
        closable
        destroyOnClose
        onCancel={onClose}
        footer={
          <Row>
            <Col span={24} flex={2}>
              <Button
                type="default"
                data-testid="cancel"
                onClick={onClose}
                css="margin-right: 10px;"
              >
                <FormattedMessage defaultMessage="Cancel" />
              </Button>
              <Button type="primary" data-testid="send" onClick={handleSubmit}>
                <FormattedMessage defaultMessage="Send" />
              </Button>
            </Col>
          </Row>
        }
      >
        <StyledForm form={form} layout="vertical" css="padding: 20px">
          <Row>
            <Col span={24}>
              <FormItem
                name="email"
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: intl.formatMessage({
                      defaultMessage: 'A valid email is required',
                    }),
                  },
                ]}
              >
                <Input data-testid="email" />
              </FormItem>
            </Col>
          </Row>
        </StyledForm>
      </Modal>
    </>
  );
};

export default MailReportModal;
